import { types, getParent, flow } from "mobx-state-tree"

export const NavLink = types
  .model('NavLink', {
    title: types.string,
    page: types.maybe(types.string),
    url: types.maybe(types.string)
  })

export const NavLinkGroup = types
  .model('NavLinkGroup', {
    title: types.string,
    navLinks: types.array(NavLink)
  })

export const MetaTag = types
  .model('MetaTag', {
    name: types.string,
    content: types.string
  })

export const SEOData  = types
  .model('SEOData', {
    pageUrl: types.string,
    title: types.string,
    metaTags: types.array(MetaTag),
    contentFooter: types.string
  })

export const SEOGroup  = types
  .model('SEOGroup', {
    data: types.optional(types.array(SEOData), [])
  })

export const SiteConfigStore = types
  .model("SiteConfigStore", {
    isLoading: true,
    version: types.maybe(types.number),
    domain: types.maybe(types.string),
    companyName: types.maybe(types.string),
    companyTagLine: types.maybe(types.string),
    quoteDistributorEmail: types.maybe(types.string),
    quoteDistributorBCCs: types.maybe(types.string),
    trackingCode: types.optional(types.array(types.string), []),
    assetDirectory: types.maybe(types.string),
    desktopNavLinks: types.optional(types.array(NavLink), []),
    mobileNavLinks: types.optional(types.array(NavLink), []),
    footerNavLinks: types.optional(types.array(NavLinkGroup), []),
    seo: types.optional(SEOGroup, { data: [] })
  })
  .views(self => ({
    get shop() {
      return getParent(self)
    },
    get metaTagData() {
      const url = self.shop.view.currentUrl;
      let returnData = [];
      
      for (let idx = 0; idx < self.seo.data.length; idx++) {
        const seoData = self.seo.data[idx];
        
        if (seoData.pageUrl == url) {
          returnData = seoData.metaTags;
          break;
        }
        else if (seoData.pageUrl == '')
          returnData = seoData.metaTags;
      }
        
      return returnData;
    },
    get contentFooter() {
      const url = self.shop.view.currentUrl;
      let returnData = '';
      
      for (let idx = 0; idx < self.seo.data.length; idx++) {
        const seoData = self.seo.data[idx];
        
        if (seoData.pageUrl == url) {
          returnData = seoData.contentFooter;
          break;
        }
        else if (seoData.pageUrl == '')
          returnData = seoData.contentFooter;
      }
        
      return returnData;
    },
    get title() {
      const url = self.shop.view.currentUrl;
      let returnData = '';
      
      for (let idx = 0; idx < self.seo.data.length; idx++) {
        const seoData = self.seo.data[idx];
        
        if (seoData.pageUrl == url) {
          returnData = seoData.title;
          break;
        }
        else if (seoData.pageUrl == '')
          returnData = seoData.title;
      }
        
      return returnData;
    }

  }))
  .actions(self => {

    let siteConfigLoadPromise;

    function markLoading(loading) {
      self.isLoading = loading
    }

    function updateSiteConfig(json) {
      console.log(json);

      self.version = json.version;
      self.domain = json.domain;
      self.siteTitle = json.siteTitle;
      self.companyName = json.companyName;
      self.companyTagLine = json.companyTagLine;
      self.trackingCode = json.trackingCode;
      self.trackingCodeHead = json.trackingCodeHead;
      self.assetDirectory = json.assetDirectory;

      if (json.hasOwnProperty('desktopNavLinks')) {
        json.desktopNavLinks.forEach(navLink => {
          self.desktopNavLinks.push(NavLink.create(navLink))
        });
      }
      if (json.hasOwnProperty('mobileNavLinks')) {
        json.mobileNavLinks.forEach(navLink => {
          self.mobileNavLinks.push(NavLink.create(navLink))
        });
      }

      if (json.hasOwnProperty('footerNavLinks')) {
        json.footerNavLinks.forEach(navLinkGroup => {
          self.footerNavLinks.push(NavLinkGroup.create(navLinkGroup))
        });
      }

      if (json.hasOwnProperty('seo')) {
        self.seo = SEOGroup.create(json.seo);
      }
    }

    const _loadSiteConfig = flow(function* loadSiteConfig() {
      try {
        const json = yield self.shop.fetch("/api/config");
        updateSiteConfig(json)
        markLoading(false)
      } catch (err) {
        console.error("Failed to load site config ", err)
      }
    })

    function loadSiteConfig() {
      if (siteConfigLoadPromise)
        return siteConfigLoadPromise;

      siteConfigLoadPromise = _loadSiteConfig();
      return siteConfigLoadPromise;
    }

    return {
      updateSiteConfig,
      loadSiteConfig
    }
  })

export default SiteConfigStore